import {useController} from "react-hook-form";
import {LabelField, LabelFieldProps} from "@/components/form/LabelField";
import {Combobox, ComboboxProps} from "@/components/Combobox";


type ComboboxFieldProps<O extends any, GetValueFn extends ((option: O) => any)> =
    Omit<ComboboxProps<O, GetValueFn>, 'onBlur' | 'onChange' | 'value'>
    & LabelFieldProps
    & {
    options: O[]
}

export function ComboboxField<O extends any, GetValueFn extends ((option: O) => any)>({
                                  searchText = "Search ...",
                                  notFoundText = "No results found",
                                  label,
                                  children,
                                  name,
                                  containerClassName,
                                  hideError,
                                  options,
                                  ...props
                              }: ComboboxFieldProps<O,GetValueFn>) {
    const {field} = useController({name})
    return (
        <LabelField label={label} name={name} containerClassName={containerClassName} hideError={hideError}>
            <Combobox<O, (option: O) => typeof field.value>
                value={field.value}
                options={options}
                onBlur={field.onBlur}
                onChange={field.onChange}
                {...props}
            />
        </LabelField>
    )
}

ComboboxField.displayName = "ComboboxField";

